import { Info, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Instructions card component
 */
export function InstructionsCard({ instructions, showInstructions, setShowInstructions }) {
  return (
    <Card className={`bg-gradient-to-br ${
      instructions.title.includes('alge') 
        ? 'from-blue-50 to-blue-100 border-blue-200' 
        : 'from-green-50 to-green-100 border-green-200'
    }`}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center justify-between">
          <span className="flex items-center gap-2">
            <Info className="w-5 h-5" />
            {instructions.title}
          </span>
          <button
            type="button"
            onClick={() => setShowInstructions(!showInstructions)}
            className="text-sm font-normal text-gray-600 hover:text-gray-900"
          >
            {showInstructions ? 'Skjul' : 'Vis'}
          </button>
        </CardTitle>
      </CardHeader>
      
      {showInstructions && (
        <CardContent className="space-y-3">
          {instructions.steps.map((step, i) => (
            <div key={i} className="flex gap-3">
              <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0 ${
                instructions.title.includes('alge') ? 'bg-blue-500' : 'bg-green-500'
              }`}>
                {i + 1}
              </div>
              <div>
                <div className="font-medium text-gray-900">{step.title}</div>
                <div className="text-sm text-gray-600">{step.desc}</div>
              </div>
            </div>
          ))}
          
          {instructions.steps.some(s => s.desc.includes('⚠️')) && (
            <div className="mt-4 p-3 bg-amber-100 rounded-lg border border-amber-300 flex items-start gap-2">
              <AlertCircle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
              <div className="text-sm text-amber-800">
                <strong>Viktig!</strong> Les alle sikkerhetsinstruksjoner nøye før prøvetaking.
              </div>
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}
